// extracted by mini-css-extract-plugin
export var formContainer = "_m9-0";
export var message = "_m9-1";